// CartItemApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'CartItem'];

// Enhance the base API service by adding entication-related tag types
const CartItemApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
      updateStatusCommission: build.mutation({
        query: ({ id, statusCommission, validateDateTime }) => ({
          url: `/cart-items/updateStatusCommission`, // Pass status correctly
          method: 'PATCH',
          data: JSON.stringify({
            id, // The cart item ID
            statusCommission, // The new status
            validateDateTime, // The timestamp of validation
          }),  
        }),
        providesTags: ['CartItem'],
      }),
          // Fetch Count of Distinct Carts and Total Price by Seller ID and Status
      getStatusTotalByUserId: build.query({
        query: ({ sellerId, isActive }) => ({
          url: `/cart-items/sellerId-status-total`,
          params: { sellerId, isActive }, // Pass query parameters
        }),
        providesTags: ['CartItem'],
      }),

           // Fetch Count of Distinct Carts and Total Price by Seller ID and Status
      getStatusDayTotalByUserId: build.query({
            query: ({ sellerId, isActive }) => ({
              url: `/cart-items/sellerId-status-total-day`,
              params: { sellerId, isActive }, // Pass query parameters
            }),
            providesTags: ['CartItem'],
          }),

               // Fetch Count of Distinct Carts and Total Price by Seller ID and Status
      getStatusMonthTotalByUserId: build.query({
        query: ({ sellerId, isActive }) => ({
          url: `/cart-items/sellerId-status-total-month`,
          params: { sellerId, isActive }, // Pass query parameters
        }),
        providesTags: ['CartItem'],
      }),

           // Fetch Count of Distinct Carts and Total Price by Seller ID and Status
           getStatusYearTotalByUserId: build.query({
            query: ({ sellerId, isActive }) => ({
              url: `/cart-items/sellerId-status-total-year`,
              params: { sellerId, isActive }, // Pass query parameters
            }),
            providesTags: ['CartItem'],
          }),
       
    }),
    overrideExisting: false,
  });

export default CartItemApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useUpdateStatusCommissionMutation,
    useGetStatusTotalByUserIdQuery,

    useGetStatusDayTotalByUserIdQuery,
    useGetStatusMonthTotalByUserIdQuery,
    useGetStatusYearTotalByUserIdQuery
} = CartItemApi;



